/**
 * ProgressRail Component
 *
 * Fixed sidebar progress indicator showing interview progress with clickable dots
 */

import React from 'react';

/**
 * @param {Object} props
 * @param {number} props.currentQuestion - Current question number (1-based)
 * @param {number} props.totalQuestions - Total number of questions
 * @param {Function} props.onQuestionClick - Callback when a question dot is clicked
 */
export default function ProgressRail({ currentQuestion, totalQuestions, onQuestionClick }) {
  const isLargeSet = totalQuestions > 12;

  return (
    <div className="hidden xl:block fixed right-8 top-1/2 -translate-y-1/2 z-40">
      <div className="relative flex flex-col items-center gap-1.5 py-4 px-2 bg-white/40 backdrop-blur-sm rounded-full border border-gray-100/50">
        {/* Track line - background */}
        <div
          className="absolute top-6 bottom-6 w-1 bg-gray-100 rounded-full z-0"
          style={{ left: '50%', transform: 'translateX(-50%)' }}
        />

        {/* Filled portion */}
        <div
          className="absolute top-6 w-1 bg-[#F47920] rounded-full z-10 transition-all duration-700 ease-in-out"
          style={{
            left: '50%',
            transform: 'translateX(-50%)',
            height: totalQuestions > 1 ? `${((currentQuestion - 1) / (totalQuestions - 1)) * (100 - (12 / totalQuestions * 100))}%` : '0%',
            maxHeight: 'calc(100% - 48px)'
          }}
        />

        {/* Question dots */}
        {Array.from({ length: totalQuestions }).map((_, index) => {
          const num = index + 1;
          const isCompleted = num < currentQuestion;
          const isCurrent = num === currentQuestion;
          const isFuture = num > currentQuestion;

          return (
            <button
              key={num}
              onClick={() => !isFuture && onQuestionClick(num)}
              title={`Question ${num}`}
              className={`relative z-20 rounded-full flex items-center justify-center transition-all duration-300 outline-none ${
                isCurrent
                  ? 'w-7 h-7 border-2 border-[#F47920] bg-white shadow-lg shadow-orange-200 active:scale-90'
                  : isCompleted
                    ? 'w-5 h-5 bg-[#F47920] hover:scale-110'
                    : 'w-3 h-3 bg-gray-200'
              } ${isFuture ? 'cursor-default opacity-60' : 'cursor-pointer'}`}
              disabled={isFuture}
            >
              {isCurrent && !isLargeSet && (
                <span className="text-[10px] font-black text-[#F47920]">
                  {num}
                </span>
              )}
              {isCompleted && !isLargeSet && (
                <span className="text-[9px] font-black text-white">
                  {num}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
